/**
 * Custom logic for setting the correct device id.
 *
 * @param {AmplitudeClient} _amplitude - The amplitude instance.
 * @returns {void}
 */
export function fixDeviceID(_amplitude) {
    return new Promise(resolve => resolve(true));
}
